import { useNavigate } from "react-router-dom";

import { config } from "config";

import logo from "@assets/img/logo/logo-symbol.svg";
import logoText from "@assets/img/logo/logo-text.svg";

import { Button } from "@components/buttons/button";
import { Card } from "react-bootstrap";
import { ZuAuthStore } from "@hooks/stores/zustand-auth-store";

export function Land() {
  const { customer } = ZuAuthStore();
  const navigate = useNavigate();

  const platforms = [
    {
      name: "Cannabis & Saúde",
      description: "Plataforma sobre Cannabis Medicinal",
      logo: config.logos.ces,
      link: "https://www.cannabisesaude.com.br/",
    },
    {
      name: "TegraPharma",
      description: "Plataforma sobre Cannabis Medicinal",
      logo: config.logos.tegra,
      link: "https://tegrapharma.com/",
    },
    {
      name: "TegraPharma Corp",
      description: "Plataforma sobre Cannabis Medicinal",
      logo: config.logos.tegracorp,
      link: "http://tegrapharmacorp.com/",
    },
    {
      name: "Vigo Academy",
      description: "Plataforma sobre Cannabis Medicinal",
      logo: config.logos.vigo,
      link: "https://vigoacademy.com.br/",
    },

    {
      name: "CanteraMed",
      description: "Plataforma sobre Cannabis Medicinal",
      logo: config.logos.ces,
      link: "https://canteramed.com/",
    },
    {
      name: "Consultando em 321",
      description: "Plataforma sobre Cannabis Medicinal",
      logo: config.logos.ces,
      link: "http://consultandoem321.com.br/",
    },
    {
      name: "Odonto Cannabis Summit",
      description: "Plataforma sobre Cannabis Medicinal",
      logo: config.logos.odontocansummit,
      link: "https://odontocannabissummit.com.br/",
    },
    {
      name: "Consulta CS",
      description: "Plataforma sobre Cannabis Medicinal",
      logo: config.logos.ces,
      link: "https://consultacs.com.br/",
    },
  ];

  return (
    <>
      <div
        className="container-fluid"
        style={{
          paddingTop: "1rem",
          paddingLeft: "clamp(1rem, 5vw, 10rem)",
          paddingRight: "clamp(1rem, 5vw, 10rem)",
        }}
      >
        {/* Header */}
        <div className="row">
          <div className="col-md-12">
            <div className="d-flex flex-column flex-md-row justify-content-between align-items-center gap-3">
              <div className="col-12 col-md-6 text-center text-md-start">
                <img
                  src={logo}
                  style={{ height: "clamp(40px, 7vw, 70px)" }}
                  alt="Logo"
                />
                <img
                  src={logoText}
                  className="ps-3"
                  style={{ height: "clamp(30px, 5vw, 50px)" }}
                  alt="Logo"
                />
              </div>
              <div className="col-12 col-md-6">
                <div className="d-flex flex-column flex-sm-row justify-content-md-end align-items-center gap-3 gap-md-4">
                  <Button
                    className="btn btn-success text-white px-4 px-md-5 py-2 py-md-3"
                    onClick={() => navigate(customer ? `/home` : `/login`)}
                  >
                    <span className="fs-6 fs-md-5 fw-bold">
                      {customer ? `Dashboard` : `Entrar`}
                    </span>
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Begin */}
        <div
          className="row pb-5"
          style={{ marginTop: "clamp(2rem, 5vw, 5rem)" }}
        >
          <div className="col-md-12">
            <div className="d-flex flex-column flex-lg-row justify-content-between align-items-center gap-4">
              {/* Init */}
              <div className="col-12">
                <div className="d-flex flex-column gap-3 gap-md-5">
                  <span className="fw-bold fs-1">
                    Plataforma Tecnológica do Grupo {config.appName}
                  </span>
                  <span className="fs-4 fs-md-5">
                    Plataforma de administração e centralização das afiliadas{" "}
                    {config.appName}.
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Platforms */}
      <div
        className="row"
        style={{
          backgroundColor: "#e9f6ff",
          paddingTop: "clamp(3rem, 8vw, 10rem)",
          paddingBottom: "clamp(2rem, 5vw, 5rem)",
        }}
      >
        {/* Message */}
        <div className="col-12 col-md-10 col-lg-8 offset-md-1 offset-lg-2 text-center mb-4 mb-md-5 px-3">
          <span
            className="fw-bold"
            style={{
              fontSize: "clamp(1.5rem, 3.5vw, 2.5rem)",
              lineHeight: "1.3",
            }}
          >
            {config.appName}: algumas de nossas responsabilidades.
          </span>
        </div>

        {/* Cards */}
        <div className="col-12 offset-md-1 offset-lg-2 col-md-10 col-lg-8 px-3">
          <div className="row g-4">
            {platforms.map((platform, index) => (
              <div key={index} className="col-12 col-sm-6 col-lg-4">
                <Card
                  className="h-100 shadow-sm border-0"
                  style={{
                    transition: "transform 0.3s ease, box-shadow 0.3s ease",
                    cursor: "pointer",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "translateY(-8px)";
                    e.currentTarget.style.boxShadow =
                      "0 12px 24px rgba(0,0,0,0.15)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 2px 8px rgba(0,0,0,0.1)";
                  }}
                  onClick={() => {
                    window.open(
                      platform.link || "#",
                      "_blank",
                      "noopener,noreferrer"
                    );
                  }}
                >
                  <Card.Body className="d-flex flex-column align-items-center text-center p-4">
                    <img
                      src={platform.logo}
                      alt={platform.name}
                      style={{
                        height: "80px",
                        width: "auto",
                        marginBottom: "1rem",
                        objectFit: "contain",
                      }}
                    />
                    <Card.Title
                      className="fw-bold mb-2"
                      style={{ fontSize: "1.1rem" }}
                    >
                      {platform.name}
                    </Card.Title>
                    <Card.Text
                      className="text-muted"
                      style={{ fontSize: "0.95rem" }}
                    >
                      {platform.description}
                    </Card.Text>
                  </Card.Body>
                </Card>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Footer */}
      <div
        className="d-flex flex-column justify-content-center text-center"
        style={{ marginTop: "1.5rem", marginBottom: "2.5rem" }}
      >
        <span className="">
          © {new Date().getFullYear()}, {config.appName}, feito por{" "}
          <i className="fa fa-heart heart text-danger"></i>
          <a href="http://www.code2business.com/" target="_blank">
            Code2Business
          </a>{" "}
          Ltda.
        </span>
        <span className="">Todos os direitos reservados</span>
      </div>
    </>
  );
}
